import { Flex, Tag } from '@chakra-ui/react'

export const RowsDoubleTableCaption = (props) => {
	const { total } = props
	return (
		<Flex direction='row'>
			<Tag colorScheme='blue'>Total: {total}</Tag>
		</Flex>
	)
}
 